<template>
  <v-form ref="loginForm" v-model="valid" @submit.prevent="handleLogin">
    <v-text-field v-model="username" :rules="usernameRules" label="Usuário" prepend-inner-icon="mdi-account"
      variant="outlined" class="mb-4" color="primary" required />

    <v-text-field v-model="password" :rules="passwordRules" :type="showPassword ? 'text' : 'password'" label="Senha"
      prepend-inner-icon="mdi-lock" :append-inner-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
      @click:append-inner="showPassword = !showPassword" variant="outlined" class="mb-4" color="primary" required />

    <!-- <v-row>
      <v-col cols="12" md="6">
        <v-checkbox v-model="rememberMe" label="Manter-me conectado" color="green-darken-3" hide-details />
      </v-col>

      <v-col cols="12" md="6">
        <v-btn variant="text" color="primary" size="small" @click="handleForgotPassword">
          Esqueci minha senha
        </v-btn>
      </v-col>
    </v-row> -->

    <v-btn type="submit" color="green-darken-3" size="large" block :loading="loading" :disabled="!valid">
      Acessar
    </v-btn>
  </v-form>
</template>

<script setup>
import { ref, reactive } from 'vue'
import { useAuthStore } from '@/stores/auth';
import { useRouter } from 'vue-router';
import { useToastStore } from '@/stores/toast';

const toast = useToastStore()

const valid = ref(false)
const loading = ref(false)
const showPassword = ref(false)
const username = ref('')
const password = ref('')
const rememberMe = ref(false)
const error = ref('');

const auth = useAuthStore();
const router = useRouter();

const usernameRules = [
  v => !!v || 'Usuário é um campo obrigatório',
  v => (v && v.length >= 5) || 'O nome de usuário deve possuir no mínimo 5 caractéres'
]

const passwordRules = [
  v => !!v || 'Senha é um campo obrigatório',
  v => (v && v.length >= 5) || 'A senha deve possuir no mínimo 5 caractéres'
]

const loginForm = ref(null)

const handleLogin = async () => {
  if (!valid.value) return

  loading.value = true

  try {
    const res = await auth.login(username.value, password.value);

    await auth.fetchUser();
    router.push('/')

  } catch (error) {
    toast.error('Usuário ou senha inválidos')
  } finally {
    loading.value = false
  }
}

</script>
